import React, { useEffect, useState } from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { authService } from '../services/api';

export const ProtectedRoute = ({ children }) => {
  const location = useLocation();
  const [checking, setChecking] = useState(true);
  const [user, setUser] = useState(authService.getCurrentUser());

  useEffect(() => {
    const verify = async () => {
      const refreshed = await authService.refreshUser();
      setUser(refreshed);
      setChecking(false);
    };
    if (user) {
      setChecking(false);
    } else {
      verify();
    }
  }, []);

  if (checking) {
    return null;
  }

  if (!user) {
    return <Navigate to="/login" replace />;
  }

  if (user.must_change_password && location.pathname !== '/changer-mot-de-passe') {
    return <Navigate to="/changer-mot-de-passe" replace />;
  }

  if (!user.must_change_password && location.pathname === '/changer-mot-de-passe') {
    return <Navigate to="/dashboard" replace />;
  }

  return children;
};

export const PublicRoute = ({ children }) => {
  const user = authService.getCurrentUser();
  if (user) {
    if (user.must_change_password) {
      return <Navigate to="/changer-mot-de-passe" replace />;
    }
    return <Navigate to="/dashboard" replace />;
  }
  return children;
};
